var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0.25C5.41421 0.25 5.75 0.585786 5.75 1V4C5.75 4.41421 5.41421 4.75 5 4.75C4.58579 4.75 4.25 4.41421 4.25 4V1C4.25 0.585786 4.58579 0.25 5 0.25Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.25C11.4142 0.25 11.75 0.585786 11.75 1V4C11.75 4.41421 11.4142 4.75 11 4.75C10.5858 4.75 10.25 4.41421 10.25 4V1C10.25 0.585786 10.5858 0.25 11 0.25Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.75C3.30964 3.75 2.75 4.30964 2.75 5V12C2.75 12.6904 3.30964 13.25 4 13.25H10.5049C10.8364 13.25 11.1544 13.1183 11.3888 12.8839L12.8839 11.3888C13.1183 11.1544 13.25 10.8364 13.25 10.5049V5C13.25 4.30964 12.6904 3.75 12 3.75H4ZM1.25 5C1.25 3.48122 2.48122 2.25 4 2.25H12C13.5188 2.25 14.75 3.48122 14.75 5V10.5049C14.75 11.2343 14.4603 11.9337 13.9445 12.4495L12.4495 13.9445C11.9337 14.4603 11.2343 14.75 10.5049 14.75H4C2.48122 14.75 1.25 13.5188 1.25 12V5Z",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6.66675C1.5 6.39061 1.72386 6.16675 2 6.16675H14C14.2761 6.16675 14.5 6.39061 14.5 6.66675C14.5 6.94289 14.2761 7.16675 14 7.16675H2C1.72386 7.16675 1.5 6.94289 1.5 6.66675Z",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8335 11.6666C9.8335 10.6541 10.6543 9.83325 11.6668 9.83325H14.0002C14.2763 9.83325 14.5002 10.0571 14.5002 10.3333C14.5002 10.6094 14.2763 10.8333 14.0002 10.8333H11.6668C11.2066 10.8333 10.8335 11.2063 10.8335 11.6666V13.9999C10.8335 14.2761 10.6096 14.4999 10.3335 14.4999C10.0574 14.4999 9.8335 14.2761 9.8335 13.9999V11.6666Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.d41c8186d3c98179d8fa8eeba58c6845.svg";
export { ForwardRef as ReactComponent };